import { render, staticRenderFns } from "./ContactMergeModal.vue?vue&type=template&id=57a16e44&scoped=true&"
import script from "./ContactMergeModal.vue?vue&type=script&lang=js&"
export * from "./ContactMergeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a16e44",
  null
  
)

export default component.exports